import { Facet } from "@/types/productListing";
import { RouteProps } from "@/types/types.ts";

export function buildFacetIdUrl(facetId: RouteProps["facetId"]): string {
  let facetIdUrl = "";

  if (facetId) {
    facetIdUrl = facetId.join("/");
  }

  if (facetIdUrl && facetIdUrl.charAt(0) !== "/") {
    facetIdUrl = `/${facetIdUrl}`;
  }

  return facetIdUrl;
}

export const getPrimaryFacetDisplayName = ({
  matchingFacetName,
  matchingDimensionName,
}: {
  matchingFacetName: string;
  matchingDimensionName: string | undefined;
}): string => {
  switch (matchingDimensionName) {
    case constants.WOMENS_SIZE_DIMENSION_NAME:
      return constants.WOMENS_SIZE_MODIFICATION;

    case constants.MENS_SIZE_DIMENSION_NAME:
      return constants.MENS_SIZE_MODIFICATION;

    case constants.AGE_RANGE_DIMENSION_NAME:
      return constants.AGE_RANGE_MODIFICATION;

    default:
      return matchingFacetName;
  }
};

export const findFirstMatchingDimensionNameInFacets = (
  dimensionNamesToSearchFor: string[],
  facets: Facet[],
): {
  matchingFacetName: string | undefined;
  matchingDimensionName: string | undefined;
} => {
  // Look in the order of dimension names defined in dimensionNamesToSearchFor
  // and stop at the first matching one
  const matchingDimensionName = dimensionNamesToSearchFor.find((dName) =>
    facets.find(({ dimensionName }) => dName === dimensionName),
  );

  const matchingFacet = facets.find(
    ({ dimensionName }) => dimensionName == matchingDimensionName,
  );

  if (matchingFacet) {
    return {
      matchingFacetName: matchingFacet.name,
      matchingDimensionName: matchingFacet.dimensionName,
    };
  }
  return { matchingFacetName: undefined, matchingDimensionName: undefined };
};

export const constants = {
  AGE_RANGE_DIMENSION_NAME: "babykidsclothingsize",
  AGE_RANGE_MODIFICATION: "Age Range",
  WOMENS_SIZE_DIMENSION_NAME: "womensclothingsize",
  WOMENS_SIZE_MODIFICATION: "Size",
  MENS_SIZE_DIMENSION_NAME: "mensclothingsize",
  MENS_SIZE_MODIFICATION: "Size",
};
